// node-modules
import ScrollMagic from 'scrollmagic';

// other
import { controller } from '../../scripts/utils/scrollmagic';

import './ctaBlock.scss';
import { SELECTORS } from '../../scripts/constants';

export function ctaBlock() {
  const container = document.querySelector('[data-cta]');
  const content = document.querySelector('[data-role="content"]');

  if (container) {
    const button = container.querySelector('[data-cta-button]');

    if (button) {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        container.classList.toggle('is-open');
      });
    }

    return new ScrollMagic.Scene({
      triggerElement: content,
      triggerHook: 'onLeave',
      offset: 200,
    })
      .setClassToggle(container, SELECTORS.active)
      // .addIndicators({ name: 'Scroll to top' })
      .addTo(controller);
  }
}
